import React from 'react'
import './Feedback.css'

const Feedback = () => {
  return (
    <div className='main-feedback'>
    <div className='feedback'>
      <div className='feedp'>
        <p>Feedback</p>
        <div>
            {/* <p className='p2'>Swajit Engineering Pvt.Ltd. > Feedback</p> */}
        </div>
      </div>
      
      <div className='feedform'>
            <form>
            <div className='formlabel'>
            <label for="fname">Your name(required)</label><br/>
            <input className='finputf' type="text" id="name" name="name"/>
            </div>

            <div className='formlabel'>
            <label for="fname">Your Email(required)</label><br/>
            <input className='finputf'  type="text" id="email" name="email"/>
            </div>

            <div className='formlabel'>
            <label for="fname">Subject</label><br/>
            <input className='finputf'  type="text" id="subject" name="subject"/>
            </div>
            
            <div className='formlabel'>
            <label for="fname">Your Message</label><br/>
            <textarea className='tinputf'  id="area" rows={15}/>
            </div>
            <input className='btnf' type='submit' value={'Send'}/>
            </form>
        </div>
        </div>
    </div>
  )
}

export default Feedback
